<template>
    <div class="tablelist">
      <div class="row align--center">
        <div class="flex xs12 md2">
          <va-input v-model="term" placeholder="Código Jefe Inmediato" @input="search">
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>
        <div class="flex xs12 md3">
          <va-input v-model="term2" placeholder="Código Docente" @input="search2">
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>
        <div class="flex xs12 md3">
          <va-input v-model="term3" placeholder="Código Programa" @input="search3">
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>
        <div class="flex xs12 md2 offset--md2">
          <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
        no-data-label="No se encuentran datos para esta busqueda"
      >
      <div>
      </div>
        <template slot="staActive" slot-scope="props">
          <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" title="Activo" v-if="props.rowData.staActive === true"/>
          <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" title="Inactivo" v-else/>
        </template>
        <template slot="actions" slot-scope="props">
          <div class="actions-container">
            <div v-for="item of fields[fields.length-1].actionRef" :key="item.id" class="action-item">
              <template v-if="item.action === 'edit'">
                <img class="imgdata ma-0" :id="props.rowData.id" src="../../assets/images/edit.png" alt="Editar Jefe" title="Editar Jefe" width="20"  @click="dataGrade(props.rowData, item.action)"/>
              </template>
              <template v-if="item.action === 'delete'">
                <img class="imgdata ma-0" :id="props.rowData.id" src="../../assets/images/inactive.png" alt="Eliminar Jefe" title="Eliminar Jefe" width="20"  @click="dataGrade(props.rowData, item.action)"/>
              </template>
            </div>
          </div>
        </template>
      </va-data-table>
    </div>
  </template>
  
  <script>
  import { debounce } from 'lodash'
  
  export default {
    data () {
      return {
        term: null,
        term2: null,
        term3: null,
        perPage: '20',
        perPageOptions: ['5', '10', '15', '20'],
        staActive: [
          {
            id: 1,
            description: 'Activo',
          },
          {
            id: 2,
            description: 'Inactivo',
          },
        ],
        staActiveModel: '',
        Grade: this.InfoView,
      }
    },
    props: {
      method: Function,
      InfoView: Array,
      HeadTable: Array,
    },
    computed: {
      fields () {
        return this.HeadTable
      },
      filteredData () {
        return this.Grade.filter(item => {
            let matchTerm = !this.term || item.idJefeInmediato.toLowerCase().includes(this.term.toLowerCase());
            let matchTerm2 = !this.term2 || item.idBannerDocente.includes(this.term2);
            let matchTerm3 = !this.term3 || item.programa.includes(this.term3);

            return matchTerm && matchTerm2 && matchTerm3;
        });
    },
    },
    methods: {
      dataGrade (user, ref) {
        this.method(user, ref)
      },
      search: debounce(function (term) {
        this.term = term
      }, 400),
      search2: debounce(function (term2) {
        this.term2 = term2
      }, 400),
      search3: debounce(function (term3) {
        this.term3 = term3;
      }, 400),
    },
  }
  </script>
  
  <style>
  .tablelist .va-button {
    color: #a2273c !important;
    border-color: #a2273c !important;
  }
  
  .tablelist .va-button--active {
    color: #ffffff !important;
    border-color: #a2273c !important;
    background-color: #a2273c !important;
  }
  
  .tablelist .va-select__label {
    color: #a2273c !important;
  }
  .va-select__option--selected {
    color: #a2273c !important;
  }
  
  .tablelist .va-button--small .va-button__content__title {
    color: #ffffff !important;
  }
  
  .va-table th,
  .content table th {
    border-bottom: 2px solid #a2273c !important;
    font-size: 12px !important;
  }
  
  .va-data-table__vuetable th.sortable {
    color: #a2273c !important;
  }
  
  .imgdata{
    cursor: pointer;
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .actions-container {
  display: flex;
  gap: 8px; /* Espaciado entre los elementos */
  align-items: center; /* Alineación vertical */
}

.action-item {
  display: flex;
  align-items: center;
}

  </style>
  